export default {"src":"/_next/static/media/erythritol.19814f5b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};